import axios from "axios";

const baseApiPostProd = process.env.REACT_APP_API_BASE_URL_PROD;
const baseApiGetProd = process.env.REACT_APP_API_BASE_URL_PROD;

// ✅ Unified error handler
const handleResponseError = (message) => {
  return {
    success: false,
    message: message !== "" ? message : "Server error",
  };
};

// ✅ Unified response handler
const handleResponseSuccess = (response) => {
  return {
    success: true,
    data: response.data?.data,
    message: response.data.message,
  };
};
const handleResponseSuccessPagination = (response) => {
  return {
    success: true,
    data: response.data?.data,
    total: response.data?.pagination?.total,
    totalPage: response.data?.pagination?.totalPages,
    message: response.data.message,
  };
};

// ✅ Exported helpers
export const postApiProd = async (endpoint, headers, params, body) => {
  try {
    const response = await axios({
      method: "post",
      url: baseApiPostProd + endpoint,
      headers: headers,
      params,
      data: body,
    });
    if (
      response.code == 200 ||
      response.status == 200 ||
      response?.data?.code == 200
    )
      return handleResponseSuccess(response);
    else
      return handleResponseError(
        response?.data?.message || "internal server error"
      );
  } catch (error) {
    console.log(error.response.data);
    return handleResponseError(
      error.response.data.message ?? "internal server error"
    );
  }
};

export const getApiProd = async (endpoint, headers, params) => {
  try {
    const response = await axios({
      method: "get",
      url: baseApiPostProd + endpoint,
      headers: headers,
      params,
    });
    if (
      response.code == 200 ||
      response.status == 200 ||
      response?.data?.code == 200
    )
      return handleResponseSuccess(response);
    else
      return handleResponseError(
        response?.data?.message || "internal server error"
      );
  } catch (error) {
    return handleResponseError("internal server error");
  }
};
export const getApiPaginationProd = async (endpoint, headers, params) => {
  try {
    const response = await axios({
      method: "get",
      url: baseApiPostProd + endpoint,
      headers: headers,
      params,
    });
    if (
      response.code == 200 ||
      response.status == 200 ||
      response?.data?.code == 200
    )
      return handleResponseSuccessPagination(response);
    else
      return handleResponseError(
        response?.data?.message || "internal server error"
      );
  } catch (error) {
    return handleResponseError("internal server error");
  }
};
